import { columns } from "./columns"

export const footer = {
    columns,
    copyright: `© ${new Date().getFullYear()} EMTECH, Inc. All rights reserved.`,
    logo: {
        src: {
            light: "/emtech-logo-light.svg", dark: "/emtech-logo-dark.svg"
        },
        alt: "EMTECH",
        width: 120,
    },
}
